import { render, staticRenderFns } from "./RootModal.vue?vue&type=template&id=f8fbbf8a&scoped=true&"
import script from "./RootModal.vue?vue&type=script&lang=js&"
export * from "./RootModal.vue?vue&type=script&lang=js&"
import style0 from "./RootModal.vue?vue&type=style&index=0&id=f8fbbf8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fbbf8a",
  null
  
)

export default component.exports